import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { Grid } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';


import Carousel from 'react-elastic-carousel'

const styles = theme => ({
    container: {
        height:230,
        borderRadius: 10,
        backgroundColor: theme.palette.background.box,
        padding: theme.spacing(2),
        //marginBottom: theme.spacing(24),
    },
    item: {
        width: 200,
        height: 180,
        marginLeft: '5%',
        marginRight: '5%',
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        // justifyContent: 'center',
        alignItems: 'center',
        // paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 4,
        cursor: 'pointer'
    },
    item_image: {
        height: 100,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        // marginTop: 8,
    },
    item_name: {
        height: 40,
    },
})
function UpsellProductsComponent(props) {
        const { upsellProducts, currency,onSelectUpsellProduct, classes, t } = props;
        //console.log("AAAAAA upsellProducts:", upsellProducts)
        let width = window.innerWidth
        let number = (width*40/100)/180; 
        if(width<600){
            number = width/300; 
        }
        
        return (
            <Grid item className={classes.container}>
                <CustomTypo center variant='subtitle2'>{t('consider_an_upgrade')}</CustomTypo>

        {/* <CarouselProvider
                                        naturalSlideWidth={100}
                                        naturalSlideHeight={130}
                                        totalSlides={upsellProducts.length}
                                        visibleSlides={number}
                                        isPlaying={true}
                                        interval={2000}
                                        touchEnabled={true}
                                        dragStep={3}
                                    >
                                    <Slider>
                                    {upsellProducts.map((product, index) =>
                                        <Slide key={index} index={index}> <ProductComponent classes={classes} key={index} index={index} product={product} currency={currency} onSelectUpsellProduct={onSelectUpsellProduct}/></Slide>
                                        )}
                                    </Slider>
                                    </CarouselProvider> */}

                                    <Carousel itemsToShow={number}>
                                    {upsellProducts.map((product, index) =>
                                        <ProductComponent classes={classes} key={index} index={index} product={product} currency={currency} onSelectUpsellProduct={onSelectUpsellProduct}/>
                                        )}
                                    </Carousel>
            </Grid>
        )
}

function ProductComponent(props) {
    var {classes, product} = props
    var price = dataUtil.getProductPrice(product.pricing) ? dataUtil.getProductPrice(product.pricing).toFixed(2) : "0.00"
    return (
        <Grid item onClick={() => props.onSelectUpsellProduct(product)} className={classes.item}>
            <Grid item className={classes.item_image}>
                <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item)} />
            </Grid>
            <Grid item className={classes.item_name}>
                <CustomTypo center variant='body2'>{product.name}</CustomTypo>
            </Grid>
            <Grid item className={classes.item_header}>
                <CustomTypo center mg_top_xs variant='subtitle2'>{props.currency}{price}</CustomTypo>
            </Grid>
        </Grid>
    )
}

function ProductImage(props) {
    var {classes, image} = props
    if (image && image.url) {
        return <img src={image.url } style={{height: 100, width: '100%',borderTopLeftRadius: 4,borderTopRightRadius: 4, objectFit: 'contain'}} />
    } else {
        return <Grid item className={classes.item_image} />
    }
}

export default withStyles(styles)(withTranslation()(UpsellProductsComponent));